module.exports = __webpack_public_path__ + "video/B-A-005_SAF_BTB_WorkingFromHome_v3.baedad44.vtt";